// Modules
require('./news/js/news');
require('./solr/js/autosuggest');
require("./solr/js/search_controller");
